import { render, staticRenderFns } from "./ResponsiblePriceView.vue?vue&type=template&id=09fd16e0&scoped=true"
import script from "./ResponsiblePriceView.vue?vue&type=script&lang=js"
export * from "./ResponsiblePriceView.vue?vue&type=script&lang=js"
import style0 from "./ResponsiblePriceView.vue?vue&type=style&index=0&id=09fd16e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd16e0",
  null
  
)

export default component.exports